<template>
  <el-tabs
    v-model="tabIndex"
    @tab-click="handleClick"
  >
    <el-tab-pane
      :key="item.name"
      v-for="item in tabList"
      :label="item.title"
      :name="item.name"
      lazy="true"
    >
      <slot />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
    export default {
      name: "bspTabs",
      props:{
          tabList:{
               type: Array,
               default: () =>{
                 []
               }
          },
          tabIndex:{
              type:String,
              default:''
          }
      },
      computed: {

      },
      data() {
        return {}
      },
      created(){
           console.log()
      },
      mounted(){

      },
      methods:{
          handleClick(tab, event){
            this.$emit('changeTab', tab,event)
        }
      }
    }
</script>
